module.exports = __webpack_public_path__ + "img/download_gift2.77fd2a4e.png";